"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var my_contributions_1 = __importDefault(require("../constants/actions/my-contributions"));

var remote_items_1 = __importDefault(require("../constants/actions/remote-items"));

var app_1 = __importDefault(require("../constants/actions/app"));

var auth_1 = __importDefault(require("../constants/actions/auth"));

var remote_item_edit_1 = __importDefault(require("../constants/actions/remote-item-edit"));

var UtilsArray = __importStar(require("../utils/array"));

var remote_item_approve_state_1 = __importDefault(require("../constants/remote-item-approve-state"));

function default_1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    list_pending: [],
    list_rejected: [],
    list_detached: [],
    last_pending_marker: null,
    last_rejected_marker: null,
    last_detached_marker: null,
    is_loading_pending: false,
    is_loading_rejected: false,
    is_loading_detached: false,
    is_reloading_pending: false,
    is_reloading_rejected: false,
    is_reloading_detached: false,
    is_loading_attach: false,
    error: null,
    error_on_attach: null,
    menu_index: 0
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case remote_items_1.default.REMOVE_SUCCESS:
      {
        return Object.assign({}, state, {
          list_pending: UtilsArray.removeByProps(state.list_pending, {
            id: action.item_id
          }),
          list_rejected: UtilsArray.removeByProps(state.list_rejected, {
            id: action.item_id
          }),
          list_detached: UtilsArray.removeByProps(state.list_detached, {
            id: action.item_id
          })
        });
      }

    case remote_items_1.default.DETACH_SUCCESS:
      {
        return Object.assign({}, state, {
          list_pending: UtilsArray.removeByProps(state.list_pending, {
            id: action.item_id
          }),
          list_rejected: UtilsArray.removeByProps(state.list_rejected, {
            id: action.item_id
          })
        });
      }

    case remote_item_edit_1.default.CONTRIBUTE_SUCCESS:
    case remote_items_1.default.CONTRIBUTE_SUCCESS:
      {
        var list = state.list_pending;
        var item = action.item;
        var approve_state = action.approve_state;

        if (approve_state === remote_item_approve_state_1.default.PENDING) {
          return Object.assign({}, state, {
            list_pending: UtilsArray.unshift(list, item)
          });
        } else {
          return state;
        }
      }

    case remote_item_edit_1.default.EDIT_SUCCESS:
    case remote_items_1.default.EDIT_SUCCESS:
      {
        var itemData = action.item;
        var itemId = action.item_id;
        return Object.assign({}, state, {
          list_pending: UtilsArray.replaceByProps(state.list_pending, {
            id: itemId
          }, itemData),
          list_rejected: UtilsArray.replaceByProps(state.list_rejected, {
            id: itemId
          }, itemData),
          list_detached: UtilsArray.replaceByProps(state.list_detached, {
            id: itemId
          }, itemData)
        });
      }

    case my_contributions_1.default.GET_PENDING_INIT:
      return Object.assign({}, state, {
        is_loading_pending: true,
        error: null
      });

    case my_contributions_1.default.GET_PENDING_SUCCESS:
      return Object.assign({}, state, {
        is_loading_pending: false,
        list_pending: action.list,
        last_pending_marker: action.marker,
        list_rejected: [],
        last_rejected_marker: null,
        list_detached: [],
        last_detached_marker: null
      });

    case my_contributions_1.default.GET_PENDING_FAILURE:
      return Object.assign({}, state, {
        is_loading_pending: false,
        error: action.error
      });

    case my_contributions_1.default.GET_REJECTED_INIT:
      return Object.assign({}, state, {
        is_loading_rejected: true,
        error: null
      });

    case my_contributions_1.default.GET_REJECTED_SUCCESS:
      return Object.assign({}, state, {
        is_loading_rejected: false,
        list_rejected: action.list,
        last_rejected_marker: action.marker,
        list_pending: [],
        last_pending_marker: null,
        list_detached: [],
        last_detached_marker: null
      });

    case my_contributions_1.default.GET_REJECTED_FAILURE:
      return Object.assign({}, state, {
        is_loading_rejected: false,
        error: action.error
      });

    case my_contributions_1.default.GET_DETACHED_INIT:
      return Object.assign({}, state, {
        is_loading_detached: true,
        error: null
      });

    case my_contributions_1.default.GET_DETACHED_SUCCESS:
      return Object.assign({}, state, {
        is_loading_detached: false,
        list_detached: action.list,
        last_detached_marker: action.marker,
        list_pending: [],
        last_pending_marker: null,
        list_rejected: [],
        last_rejected_marker: null
      });

    case my_contributions_1.default.GET_DETACHED_FAILURE:
      return Object.assign({}, state, {
        is_loading_detached: false,
        error: action.error
      });

    case my_contributions_1.default.RELOAD_PENDING_INIT:
      return Object.assign({}, state, {
        is_reloading_pending: true,
        list_pending: [],
        last_pending_marker: null,
        error: null
      });

    case my_contributions_1.default.RELOAD_PENDING_SUCCESS:
      return Object.assign({}, state, {
        is_reloading_pending: false,
        list_pending: action.list,
        last_pending_marker: action.marker
      });

    case my_contributions_1.default.RELOAD_PENDING_FAILURE:
      return Object.assign({}, state, {
        is_reloading_pending: false,
        error: action.error
      });

    case my_contributions_1.default.RELOAD_REJECTED_INIT:
      return Object.assign({}, state, {
        is_reloading_rejected: true,
        list_rejected: [],
        last_rejected_marker: null,
        error: null
      });

    case my_contributions_1.default.RELOAD_REJECTED_SUCCESS:
      return Object.assign({}, state, {
        is_reloading_rejected: false,
        list_rejected: action.list,
        last_rejected_marker: action.marker
      });

    case my_contributions_1.default.RELOAD_REJECTED_FAILURE:
      return Object.assign({}, state, {
        is_reloading_rejected: false,
        error: action.error
      });

    case my_contributions_1.default.RELOAD_DETACHED_INIT:
      return Object.assign({}, state, {
        is_reloading_detached: true,
        list_detached: [],
        last_detached_marker: null,
        error: null
      });

    case my_contributions_1.default.RELOAD_DETACHED_SUCCESS:
      return Object.assign({}, state, {
        is_reloading_detached: false,
        list_detached: action.list,
        last_detached_marker: action.marker
      });

    case my_contributions_1.default.RELOAD_DETACHED_FAILURE:
      return Object.assign({}, state, {
        is_reloading_detached: false,
        error: action.error
      });

    case my_contributions_1.default.ATTACH_ITEM_START:
      return Object.assign({}, state, {
        error_on_attach: null,
        is_loading_attach: true
      });

    case my_contributions_1.default.ATTACH_ITEM_SUCCESS:
      {
        var _itemData = action.item_data;
        return Object.assign({}, state, {
          is_loading_attach: false,
          list_pending: action.is_approved ? UtilsArray.removeByProps(state.list_pending, {
            id: action.item_id
          }) : UtilsArray.unshift(state.list_pending, _itemData),
          list_rejected: lodash_1.default.reject(state.list_rejected, {
            id: action.item_id
          }),
          list_detached: lodash_1.default.reject(state.list_detached, {
            id: action.item_id
          })
        });
      }

    case my_contributions_1.default.ATTACH_ITEM_FAILURE:
      return Object.assign({}, state, {
        is_loading_attach: false,
        error_on_attach: action.error
      });

    case app_1.default.ON_NOTI_ITEM_APPROVED:
    case app_1.default.ON_NOTI_ITEM_REJECTED:
      {
        var item_id = action.item_id;
        return Object.assign({}, state, {
          list_pending: UtilsArray.removeByProps(state.list_pending, {
            id: item_id
          })
        });
      }

    case my_contributions_1.default.ON_BLUR:
      return Object.assign({}, state, {
        list_pending: [],
        list_rejected: [],
        list_detached: [],
        last_pending_marker: null,
        last_rejected_marker: null,
        last_detached_marker: null,
        is_loading_pending: false,
        is_loading_rejected: false,
        is_loading_detached: false,
        is_reloading_pending: false,
        is_reloading_rejected: false,
        is_reloading_detached: false,
        is_loading_attach: false,
        error: null,
        error_on_attach: null,
        menu_index: 0
      });

    case auth_1.default.SIGN_OUT_SUCCESS:
      {
        return Object.assign({}, state, {
          list_pending: [],
          list_rejected: [],
          list_detached: [],
          last_pending_marker: null,
          last_rejected_marker: null,
          last_detached_marker: null,
          is_loading_pending: false,
          is_loading_rejected: false,
          is_loading_detached: false,
          is_reloading_pending: false,
          is_reloading_rejected: false,
          is_reloading_detached: false,
          is_loading_attach: false,
          error: null,
          error_on_attach: null,
          menu_index: 0
        });
      }

    case my_contributions_1.default.SELECT_MENU:
      return Object.assign({}, state, {
        menu_index: action.index
      });

    default:
      return state;
  }
}

exports.default = default_1;